"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FormValidator = /** @class */ (function () {
    function FormValidator() {
        this.validated = [];
    }
    FormValidator.prototype.validate = function (errors) {
        var state = 'valid';
        for (var _i = 0, _a = FormValidator.methods; _i < _a.length; _i++) {
            var method = _a[_i];
            this.validated.push('pb-validated-' + method);
            if (errors[method]) {
                state = method;
                break;
            }
        }
        return state;
    };
    FormValidator.methods = ['required', 'pattern'];
    return FormValidator;
}());
exports.FormValidator = FormValidator;
